/**
 * Global Loader Store
 *
 * Manages the global loading state for the entire application.
 * Can be triggered from anywhere using Alpine's store system.
 *
 * Usage:
 * - Show: this.$store.globalLoader.show()
 * - Hide: this.$store.globalLoader.hide()
 * - Toggle: this.$store.globalLoader.toggle()
 * - Check state: this.$store.globalLoader.isLoading
 */
export default {
    isLoading: false,

    show() {
        this.isLoading = true;
    },

    hide() {
        this.isLoading = false;
    },

    toggle() {
        this.isLoading = !this.isLoading;
    }
};
